import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import api from '../api/api'
import { Container, Card, Row, Col, Form, FormControl, Button, Modal, ButtonGroup, Nav } from 'react-bootstrap'
import PageTitle from '../components/common/PageTitle'
import { useTranslation } from "react-i18next";
import swal from 'sweetalert'

import LeafletMap from '../views/map'
import './AdminManagement.css'


const FarmsList = () => {

  const { t } = useTranslation();

  const [toggle, setToggle] = useState(false);

  const params = useParams();
  const [farms, setFarms] = useState([]);
  let Uid = params.uid;
  const [name, setName] = useState('')
  const [name_group, setNameGroup] = useState('')
  const [description, setDesc] = useState('')
  const [coords, setCoords] = useState({
    Latitude: "",
    Longitude: "",
    zoom: "",
    center: [],
    fromAction: false
  })
  const [layerType, setLayerType] = useState('')
  const [layer, setLayer] = useState('')
  const [configMap, setConfigMap] = useState({
    draw: {
      polygon: true,
      circle: false,
      rectangle: false,
      polyline: false,
      marker: true,
      circlemarker: true,
    },
    edit: {
      delete: false,
      edit: false
    }
  })
  const [SingleFarm, setSingleFarm] = useState([])



  const getFarmsByUser = async () => {
    await api.get(`/admin/user/${Uid}/farms`)
      .then(res => {
        let FarmsData = res.data.farms;
        setFarms(FarmsData)
      }).catch(error => {
        console.error(error)
      })
  }

  useEffect(() => {
    getFarmsByUser()
  }, [])

  const getSingleFarm = async (farmUid) => {
    let data = {
      farm_uid: farmUid,
      user_uid: Uid
    }

    await api.post('/admin/single-farm', data)
      .then(res => {
        let FarmData = res.data.farm
        setSingleFarm(FarmData)
        setName(FarmData[0].name)
        setDesc(FarmData[0].description)
        setNameGroup(FarmData[0].name_group)
      }).catch(error => {
        console.error(error)
      })
    setToggle(true)
  }


  const _onCreated = e => {
    let type = e.layerType;
    setLayerType(type)
    let layer = e.layer;
    if (type === "polygon") {
      let coords = layer._latlngs[0];
      const Coordinates = coords.map((coord) => ({
        Lat: coord.lat,
        Long: coord.lng,
      }));
      if (Coordinates)
        setLayer(JSON.stringify(Coordinates))
    } else {
      setCoords({ Latitude: layer.getLatLng().lat, Longitude: layer.getLatLng().lng });
    }

  };



  const addFarm = async () => {

    let data = {
      name: name,
      name_group: name_group,
      description: description,
      user_uid: Uid,
      Coordinates: layer,
      Latitude: coords.Latitude,
      Longitude: coords.Longitude
    }
    await api.post('/admin/add-farm', data)
      .then(response => {
        if (response.data.type === "success") {
          swal(t("farm_added"), { icon: "success" });
          getFarmsByUser()
          setName('')
          setDesc('')
          setNameGroup('')
        }
      }).catch(err => {
        console.error(err)
        swal(t("error_add_farm"), { icon: "error" })
      })
  }

  const handleEdit = (farmUid) => {

    let data = {
      name: name,
      name_group: name_group,
      description: description,
      user_uid: Uid,
      farm_uid: farmUid
    }


    api.post('/admin/edit-farm', data)
      .then(response => {
        if (response.data.type == "success") {
          swal(t("farm_updated"), {
            icon: "success",
          });
          setToggle(false)
          getFarmsByUser();
        }
        if (response.data.type && response.data.type == "danger") {
          swal({
            icon: 'error',
            title: t('Oops...'),
            text: t("error_edit_farm")
          })
          return false;
        }
      }).catch(error => {
        swal({
          icon: 'error',
          title: t('Oops...'),
          text: t("error_edit_farm")
        })
      })

  }



  const handleDelete = async farmUid => {

    let data = {
      farm_uid: farmUid,
    }
    return await api.delete('/admin/delete-farm', { data: data })
      .then(response => {
        if (response.data.type && response.data.type == "danger") {
          swal({
            title: t("cannot_delete_farm"),
            icon: "warning",
          });
          return false;
        }
        if (response.data.type == "success") {
          getFarmsByUser();
          return true;
        }
        return false;
      }).catch(error => {
        swal({
          title: t("cannot_delete_farm"),
          icon: "error",
          text: t('error_delete_farm')

        });
        return false;
      })
  }

  const confirmDelete = farmUid => {

    swal({
      title: t("Are you sure?"),
      text: t("confirm_delete_farm"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then(async (Delete) => {
        if (Delete) {
          const deleted = await handleDelete(farmUid)
          if (deleted) {
            swal(t("farm_deleted"), {
              icon: "success",
            });
          }
        }
      }).catch(error => {
        swal({
          title: t("cannot_delete_farm"),
          icon: "error",
          text: t("error_delete_farm")

        });
      })

  }



  return (
    <>
      <Container className="admin-management-page">
        <Nav justified variant="pills" className="admin-management-tabs">

          <Nav.Item>
            <Nav.Link as={Link} to={`/admin/user/${Uid}`}>
              {t('profile')}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link active>
              {t('farms')}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to={`/admin/user/${Uid}/fields`}>
              {t('fields')}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to={`/admin/user/${Uid}/sensors`}>
              {t('sensors')}
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Row noGutters className="admin-management-heading">
          <PageTitle subtitle={t('farms')} md="12" className="ml-sm-auto mr-sm-auto" />
        </Row>
        <Row>
          <Card className="admin-data-card w-100 mx-2">
          <table className="table mb-0 text-center">
            <thead className="bg-light">
              <tr>
                <th scope="col" className="border-0">{t('name_farm')}</th>
                <th scope="col" className="border-0">{t('desc')}</th>
                <th scope="col" className="border-0">{t('fields')}</th>
                <th scope="col" className="border-0"></th>
              </tr>
            </thead>
            <tbody>
              {farms.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center text-muted">
                    {t('no_farms_available')}
                  </td>
                </tr>
                ) : (

                  farms.map((item, indx) => {
                    return (

                      <tr key={item.uid}>
                        <td>{item.name}</td>
                        <td>{item.description}</td>
                        <td>
                          {item.fields != null ? Object.keys(item.fields).length : 0}
                        </td>
                        <td>
                          <ButtonGroup size="sm" className="mr-2">
                            <Button onClick={() => getSingleFarm(item.uid)} title={t('edit')}><i className="material-icons">&#xe3c9;</i></Button>
                            <Button onClick={() => confirmDelete(item.uid)} variant="danger" title={t('delete')}><i className="material-icons">&#xe872;</i></Button>
                          </ButtonGroup>
                        </td>
                      </tr>
                    )
                  })
                )}
            </tbody>
          </table>
          </Card>
          {
            SingleFarm.map(i => (
              <Modal centered size='lg' show={toggle} onHide={() => setToggle(false)} key={i.uid}>
                <Modal.Header closeButton>
                  <h6 className="m-0">{t('edit_farm')}</h6>
                </Modal.Header>
                <Modal.Body>

                  <Form>
                    <Row form className='gap-2'>
                      <Col md="6" className="form-group">
                        <p style={{ margin: "0px" }}>{t('name_farm')}</p>
                        <FormControl
                          key={i.id}
                          defaultValue={name}
                          onChange={e => setName(e.target.value)}
                        // className={`${nameError ? 'is-invalid' : ""}`}
                        />

                        <div className="invalid-feedback">{t('no_empty')}</div>

                      </Col>
                      <Col md="5" className="form-group">
                        <p style={{ margin: "0px" }}>{t('group_name')}</p>
                        <FormControl
                          key={i.id}
                          defaultValue={name_group}
                          onChange={e => setNameGroup(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Form>

                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="danger"
                    onClick={() => setToggle(false)}
                  >
                    {t('cancel')}
                    <i className="fa fa-times mx-2"></i>
                  </Button>
                  <Button
                    variant="success"
                    onClick={() => handleEdit(i.uid)}
                  >
                    {t('save')}
                    <i className="fa fa-check mx-2"></i>
                  </Button>
                </Modal.Footer>
              </Modal>
            ))
          }

        </Row>
        <Row noGutters className="admin-management-heading">
          <PageTitle subtitle={t('add_farm')} md="12" className="ml-sm-auto mr-sm-auto" />
        </Row>
        <Card small className="h-100 admin-data-card">
          <Card.Header className="border-bottom">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "auto",
                float: "left"
              }}
            >
              <h6 className="m-0">{t('farm_setup')}</h6>{" "}
            </div>
            <div className="admin-management-actions">
              <Button
                variant="success"
                disabled={layer == "" ? true : false}
                onClick={addFarm}
              >
                <i className="fa fa-check mx-2"></i>
                {t('save')}
              </Button>
              <Button
                variant="outline-primary"
                onClick={() => { setName(''); setDesc(''); setNameGroup(''); setLayer(''); setCoords({ Latitude: "", Longitude: "", zoom: "", center: [], fromAction: false }) }}
              >
                <i className="fa fa-times mx-2"></i>
                {t('cancel')}
              </Button>
            </div>
          </Card.Header>
          <Card.Body className="pt-0">
            <div
              style={{
                display: "flex",
                marginTop: "20px",
                gap:"10px",
                flexWrap: "wrap"
              }}
            >
              <Col lg="4" sm="12" md="6">
                <Form>
                  <div form>
                    <div className="form-group">
                      <p style={{ margin: "0px" }}> {t('name_farm')}</p>
                      <FormControl
                        placeholder={t('name_farm')}
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}

                      />
                    </div>
                    <div className="form-group">
                      <p style={{ margin: "0px" }}>{t('group_name')}</p>
                      <FormControl
                        placeholder={t('group_name')}
                        value={name_group}
                        onChange={(e) => setNameGroup(e.target.value)}

                      />
                    </div>
                  </div>
                </Form>
              </Col>

              <Col lg="7" md="12" sm="12" className="mb-4">
                <h6>{t('farm_map')}</h6>
                <LeafletMap _onCreated={_onCreated} uid={Uid} draw={configMap.draw} edit={configMap.edit} zoom={coords.zoom} center={coords.center} data={farms} fromAction={coords.fromAction} />

              </Col>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  )
}

export default FarmsList